import {ContentWidget} from "./content";
import React from "react";
import {useGoal} from "contexts/GoalsContext";

export const WidgetsGoals = () => {

    const { goals } = useGoal()

    return (
        <div className="row widgets-dashboard mt-4">
            <div className="col-12 col-sm-6">
                <ContentWidget
                    language="pt-BR"
                    goals={goals.goalsPt}
                />
            </div>

            <div className="col-12 col-sm-6">
                <ContentWidget
                    language="en-US"
                    goals={goals.goalsEn}
                />
            </div>
        </div>
    )
}